import isNextLink from './isNextLink';

export default isNextLink;
